import React from 'react';
import Button from '../../../components/base/Button';
import { Link } from 'react-router-dom';

export default function SupplementationHeroSection() {
  const scrollToProducts = () => {
    const productsSection = document.getElementById('products-section');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section className="pt-20 pb-20 bg-gradient-to-br from-[#FAFAFA] to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div className="space-y-6">
                <h1 className="text-5xl md:text-6xl font-bold text-[#111111] leading-tight">
                  Oxygen Access for
                  <span className="text-[#12B6B6]"> Every Community</span>
                </h1>
                <p className="text-xl text-gray-700 leading-relaxed">
                  Where oxygen deficiency is identified, DLF works to enable safe and responsible access to oxygen supplementation through community and healthcare networks.
                </p>
                <p className="text-lg text-[#12B6B6] font-semibold italic">
                  Our focus is access and awareness, not commercialization.
                </p>
              </div>

              {/* Disclaimer */}
              <div className="border-l-4 border-[#12B6B6] pl-4 py-2 bg-[#12B6B6]/5 rounded-r-xl">
                <p className="text-sm text-gray-600 italic leading-relaxed">
                  Our supplementation initiatives are designed to complement conventional medical care and should be undertaken in consultation with healthcare professionals.
                </p>
              </div>

              <div className="grid grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#111111]">10K+</div>
                  <div className="text-sm text-gray-600">Lives Reached</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#111111]">3</div>
                  <div className="text-sm text-gray-600">Access Formats</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#111111]">100%</div>
                  <div className="text-sm text-gray-600">Non-Commercial</div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/donate">
                  <Button variant="primary" size="lg">
                    Support Access Initiatives
                  </Button>
                </Link>
                <Button variant="outline" size="lg" onClick={scrollToProducts}>
                  Learn More
                </Button>
              </div>
            </div>

            {/* Right Product Showcase */}
            <div className="relative">
              <div className="aspect-square bg-gradient-to-br from-[#12B6B6]/10 to-[#12B6B6]/5 rounded-3xl p-8 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/c6fe31d50311b5fd17383c5753a60472.jfif"
                  alt="Oxygen Supplementation Access"
                  className="w-full h-full object-contain"
                />
              </div>
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 bg-white rounded-2xl p-4 shadow-lg">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium text-[#111111]">Community-Driven</span>
                </div>
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl p-4 shadow-lg">
                <div className="flex items-center space-x-2">
                  <i className="ri-shield-check-line text-[#12B6B6]"></i>
                  <span className="text-sm font-medium text-[#111111]">Healthcare-Guided</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Strip */}
      <div className="bg-[#12B6B6] py-4">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12">
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-government-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold text-sm whitespace-nowrap">Section-8 Non-Profit</span>
            </div>
            <div className="hidden sm:block w-px h-5 bg-white/40"></div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-file-shield-2-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold text-sm whitespace-nowrap">80G Tax Exemption Available</span>
            </div>
            <div className="hidden sm:block w-px h-5 bg-white/40"></div>
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-bar-chart-box-line text-white text-lg"></i>
              </div>
              <span className="text-white font-semibold text-sm whitespace-nowrap">Transparent Impact Reporting</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}